/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './api-key-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-api-key-list-page',
  template
})
export class ApiKeyListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.adm.api-keys.api-key';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {label: 'scopes', param: '', sortable: false},
    {label: 'expiry', param: '', sortable: false},
    {label: 'lastUsed', param: '', sortable: false}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    super(LocalNetworkProfile);
  }
}
